<template>
    <div v-if="popUpData" class="input-current-limit-container">
        <div class="input-current-limit-input-box">
            <span class="input-current-limit-text">
                {{
                    this.$t('dashboard.input_current_limit', {
                        i18nFallback: 'Input current limit',
                    })
                }}
            </span>
            <input
                v-model="activeCurrentLimit"
                class="input-current-limit-input-field"
                type="number"
                min="0"
                :disabled="isDisabled"
                :error="popUpData.error"
                @focus="adjustPopupPosition"
                @blur="resetPopupPosition"
            />
        </div>
        <div class="input-current-limit-suggestions">
            <span
                v-for="num in popUpData.suggestedAmperages"
                :key="num"
                class="suggestion-number"
                :class="{ selected: Number(activeCurrentLimit) === num }"
                @click="setInputValue(num)"
            >
                {{ num }}
            </span>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({})
export default class currentLimitPopUp extends Vue {
    @Prop({ default: () => ({}) }) popUpData;

    selectedNumber = null; // Stores the selected number
    current = null;
    popup = document.querySelector('.controls-popup');

    setInputValue(num) {
        this.selectedNumber = num; // Update the selected number
        if (this.popUpData) {
            switch (this.popUpData.popUpType) {
                case 'INVERTER-GRID-LIMIT':
                case 'AC-SYSTEM-GRID-LIMIT':
                    this.$set(this.popUpData.acLimits, this.popUpData.acInputIdx, num);
                    break;
                case 'CHARGING-STATION-CURRENT':
                    this.$set(this.popUpData, 'current', num);
                    break;
            }
        }
    }

    get isDisabled() {
        switch (this.popUpData.popUpType) {
            case 'INVERTER-GRID-LIMIT':
                return (
                    !this.popUpData.acLimitAdjustable[this.popUpData.acInputIdx] ||
                    this.popUpData.isWaitingForResponse
                );
            case 'CHARGING-STATION-CURRENT':
                return !this.popUpData.isManual || this.popUpData.isWaitingForResponse;
            default:
                return false;
        }
    }

    get activeCurrentLimit() {
        let value;
        switch (this.popUpData.popUpType) {
            case 'INVERTER-GRID-LIMIT':
            case 'AC-SYSTEM-GRID-LIMIT':
                value = this.popUpData.acLimits[this.popUpData.acInputIdx];
                break;
            case 'CHARGING-STATION-CURRENT':
                value = this.popUpData.current;
                break;
            default:
                return '';
        }
        return value != null && !isNaN(value) ? parseFloat(value.toFixed(1)) : ''; // Ensure correct precision to 1 decimal place
    }

    set activeCurrentLimit(value) {
        let numericValue = parseFloat(value); // Convert input to a number
        if (!isNaN(numericValue)) {
            numericValue = Math.floor(numericValue * 10) / 10; // Ensure correct precision
            this.selectedNumber = numericValue; // Update the selected number
            switch (this.popUpData.popUpType) {
                case 'INVERTER-GRID-LIMIT':
                case 'AC-SYSTEM-GRID-LIMIT':
                    this.$set(this.popUpData.acLimits, this.popUpData.acInputIdx, numericValue);
                    break;
                case 'CHARGING-STATION-CURRENT':
                    this.$set(this.popUpData, 'current', numericValue);
                    break;
            }
        } else {
            // When the input is cleared, reset selectedNumber to null
            this.selectedNumber = null;
            switch (this.popUpData.popUpType) {
                case 'INVERTER-GRID-LIMIT':
                case 'AC-SYSTEM-GRID-LIMIT':
                    this.$set(this.popUpData.acLimits, this.popUpData.acInputIdx, null);
                    break;
                case 'CHARGING-STATION-CURRENT':
                    this.$set(this.popUpData, 'current', null);
                    break;
            }
        }
    }

    /*This function is used when the keyboard to type an input pops up. This is done to ensure the pop up 
    is still visible */
    adjustPopupPosition() {
        if (this.popup) {
            this.popup.style.transform = 'translateY(-25px)';
            this.popup.scrollIntoView({ behavior: 'smooth' });
        }
    }

    resetPopupPosition() {
        // This function resets the popup position when the keyboard is dismissed
        if (this.popup) {
            this.popup.style.transition = 'transform 0.3s ease-out';
            this.popup.style.transform = 'translateY(0)'; // Reset to the original position
        }
    }
}
</script>
